import React, { useId } from "react";

export default function SharingTreeAdditionalInformation({ value, onChange, testIdPrefix = "sharing-tree", audience = "client" }) {
  const id = useId();
  return (
    <div className="mb-4">
      <label htmlFor={id} className="block text-sm font-medium mb-1.5">
        Additional information <span className="font-normal" style={{ color: "var(--fb-text-muted)" }}>(optional)</span>
      </label>
      <textarea id={id} value={value} onChange={e => onChange(e.target.value)}
        rows={3} maxLength={2000} aria-describedby={audience === "staff" ? `${id}-help` : undefined}
        placeholder="Anything else you’d like staff to know about your family"
        data-testid={`${testIdPrefix}-additional-information`}
        className="w-full px-3 py-2 rounded-lg border"
        style={{ borderColor: "var(--fb-border)" }} />
      {audience === "staff" && (
        <p id={`${id}-help`} className="text-xs mt-1" style={{ color: "var(--fb-text-muted)" }}>
          The family can also see and edit this information.
        </p>
      )}
    </div>
  );
}
